import { AppSidebar } from "@/components/app-sidebar";
import { PageLoader } from "@/components/ui/page-loader";
import { SidebarInset, SidebarProvider } from "@/components/ui/sidebar";
import { loginPath, tawkPropertyID, tawkWidgetID } from "@/constants";
import { getOrgIdWithFallback } from "@/lib/utils";
import { useAuth } from "@/providers/auth";
import { useOrg } from "@/providers/organization";
import {
  createFileRoute,
  Outlet,
  redirect,
  useRouterState,
} from "@tanstack/react-router";
import { useEffect, useState } from "react";
import { TawkLiveChat } from "tawk-react";

export const Route = createFileRoute("/$org")({
  component: AppLayoutComponent,
  beforeLoad: ({ context }) => {
    if (!context.auth.user.account) {
      throw redirect({ to: loginPath });
    }

    const orgId = getOrgIdWithFallback(context.org.orgId);

    if (!orgId) {
      throw redirect({ to: "/onboard" });
    }
  },
});

function AppLayoutComponent() {
  const router = useRouterState();
  const [showLoader, setShowLoader] = useState(false);
  const isLoading = router.status === "pending";
  const { user, getOrg } = useAuth();
  const { orgId } = useOrg();

  useEffect(() => {
    let timeoutId: number;

    if (isLoading) {
      timeoutId = setTimeout(() => {
        setShowLoader(true);
      }, 300);
    } else {
      setShowLoader(false);
    }

    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, [isLoading]);

  return (
    <SidebarProvider>
      <AppSidebar
        name=""
        email={user.account?.email ?? ""}
        orgSlug={getOrg(orgId as string)?.slug ?? ""}
      />
      <SidebarInset>
        <div className="bg-white px-8 py-2 rounded flex-1 dark:bg-background">
          {showLoader && <PageLoader />}
          <Outlet />
          <TawkLiveChat propertyId={tawkPropertyID} widgetId={tawkWidgetID} />
        </div>
      </SidebarInset>
    </SidebarProvider>
  );
}
